import { mapSelectors } from '@citypantry/util';
import { getCustomerAdvancedBudgetingState } from '../app.state';
import { CustomerAdvancedBudgetingState } from './customer-advanced-budgeting.state';

const isSubmitting = (state: CustomerAdvancedBudgetingState) => state.isSubmitting;

export const CustomerAdvancedBudgetingSelectors = mapSelectors(getCustomerAdvancedBudgetingState, {
  isSubmitting,
});
